var map = {
	"./ScreenName-AccreditedInvestor.json": [
		"xElN",
		0
	],
	"./ScreenName-AccreditedInvestorOptIn.json": [
		"I0OO",
		1
	],
	"./ScreenName-Confirmation.json": [
		"8ukv",
		2
	],
	"./ScreenName-FinancialSituation.json": [
		"3wp6",
		3
	],
	"./ScreenName-NonRecommendedProducts.json": [
		"kvZF",
		4
	],
	"./ScreenName-OrganizationInformation.json": [
		"Gt6g",
		5
	],
	"./ScreenName-RecommendedProducts.json": [
		"4DNf",
		6
	],
	"./ScreenName-ReviewAndSubmit.json": [
		"91Vq",
		7
	],
	"./ScreenName-RiskAndObjectives.json": [
		"FY4k",
		8
	],
	"./ScreenName-RiskProfileAssessment.json": [
		"fFtU",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Tzm8";
module.exports = webpackAsyncContext;